export default __webpack_public_path__ + "static/media/main_title_github.c2c4fa6e.svg";